module.exports = "/currency/assets/d4583268bf3cba54415532a463e3bb1c.jpg";